import { StateCreator } from 'zustand';

import { Store } from '@/store';
import { IProductListItem } from '@/api/types/product';

export interface IGoodsListState {
  // {currency}@{id}?{searchParams}
  goodsListKey: string;
  // 缓存和列表数据相关的数据
  goodsListCache: {
    infiniteScrollPage?: number;
    listData?: IProductListItem[];
    noMoreShow?: boolean;
    column?: number;
    expandedSections?: Record<string, boolean>;
    showFilter?: boolean;
  };
}

export interface GoodsListActions {
  setGoodsListKey: (goodsListKey: IGoodsListState['goodsListKey']) => void;
  getGoodsListCache: (
    goodsListKey: IGoodsListState['goodsListKey'],
  ) => IGoodsListState['goodsListCache'];
  setGoodsListCache: (goodsListCache: IGoodsListState['goodsListCache']) => void;
  resetGoodsList: () => void;
}

export type GoodsListSlice = IGoodsListState & GoodsListActions;

export const initialGoodsListState: IGoodsListState = {
  goodsListKey: '',
  goodsListCache: {},
};

export const createGoodsListSlice: StateCreator<Store, [], [], GoodsListSlice> = (set, get) => ({
  ...initialGoodsListState,
  setGoodsListKey: (goodsListKey) => set({ goodsListKey }),
  getGoodsListCache: (goodsListKey) => {
    if (goodsListKey && goodsListKey === get().goodsListKey) {
      return get().goodsListCache;
    }
    return {};
  },
  setGoodsListCache: (goodsListCache) => set({ goodsListCache }),
  resetGoodsList: () => set(initialGoodsListState),
});
